import React from "react";
import getStage from "../../lib/getStage";
import getDomain from "../../lib/getDomain";
import isSiteBuilder from '../../lib/isSiteBuilder';

export default function BackgroundPhoto({ children }) {
  console.log(getStage());
  console.log(getDomain());

  function getBackgroundImage(){
    if (isSiteBuilder()) return "https://assets.orenda.finance/members_orenda_finance/background.jpg";
    return `https://assets.orenda.finance/${getDomain()}/background.jpg`;
  }

  return (
    <div className="background-foto foto"
      style={{
        // height: "100vh",
        // width: "100%",
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        // flexDirection: "column",
        backgroundImage: `url(${getBackgroundImage()})`,
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // padding: 30,
      }}
    >
      <div className="content-box"
        style={{
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "space-between",
          // alignItems: "center",
          // backgroundColor: "rgba(255, 255, 255, 0.9)",
          // padding: 30,
          // borderRadius: "10px",
          // paddingLeft: 30,
          // textAlign: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
}
